export default __webpack_public_path__ + "static/media/Belt of the Ubah Kan.141b4fd3.jpg";